export default __webpack_public_path__ + "static/media/xls.05cd148b.svg";